import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import { api } from "@/lib/api";
import { School, GraduationCap, Layers, Play, RotateCcw } from "lucide-react";

export default function Admin() {
  const [graph, setGraph] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { api.graph().then(setGraph).catch(() => {}); }, []);

  const startSession = () => {
    localStorage.removeItem("mentis_sid");
    navigate("/");
  };

  const stats = graph ? [
    { icon: School, n: graph.schools.length, l: "Schools" },
    { icon: GraduationCap, n: graph.programs.length, l: "Programs" },
    { icon: Layers, n: graph.competencies.length, l: "Competencies" },
  ] : [];

  return (
    <div className="App min-h-screen">
      <Header variant="build" />
      <main className="max-w-4xl mx-auto px-5 sm:px-8 py-12">
        <div className="mono-label text-orange-600 mb-2">Data Administration</div>
        <h1 className="font-display text-3xl font-extrabold text-slate-900 tracking-tight">Mentis Control</h1>
        <p className="mt-2 text-slate-700 text-sm">Seeded competency graph, programs and academic rules across four schools.</p>

        <div className="grid grid-cols-3 gap-4 mt-8">
          {stats.map((s) => (
            <div key={s.l} className="surface rounded-2xl p-5" data-testid={`admin-stat-${s.l.toLowerCase()}`}>
              <s.icon size={20} className="text-orange-400 mb-3" />
              <div className="font-display text-3xl font-extrabold text-slate-900">{s.n}</div>
              <div className="mono-label text-slate-700 text-[9px] mt-1">{s.l}</div>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap gap-3 mt-8">
          <button data-testid="admin-launch-demo" onClick={startSession}
            className="btn-orange rounded-full px-5 py-2.5 text-sm font-semibold flex items-center gap-2">
            <Play size={15} /> Start a new session
          </button>
        </div>

        {graph && (
          <div className="mt-10">
            <div className="mono-label text-slate-700 mb-3">Competency Graph</div>
            <div className="space-y-2">
              {graph.competencies.map((c) => (
                <div key={c.id} className="surface rounded-xl px-4 py-3 flex items-center justify-between">
                  <div>
                    <span className="text-sm text-slate-900">{c.name}</span>
                    <span className="mono-label text-[9px] text-slate-700 ml-3">{c.phase}</span>
                  </div>
                  <div className="flex items-center gap-3 text-[11px] text-slate-700">
                    <span>{(graph.schools.find((s) => s.id === c.school) || {}).short}</span>
                    {c.required && <span className="text-amber-600">required</span>}
                    {c.cross_school && <span className="text-orange-400">cross-school</span>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
